<template>
    <integration-log-code-card :data="props.entry.raw_payload" :truncated="!!props.entry.raw_payload_truncated">
        <template v-slot:title> Raw Payload </template>
    </integration-log-code-card>
</template>

<script lang="ts" setup>
import IntegrationLogCodeCard from './IntegrationLogCodeCard.vue';
import type { IntegrationLogEntry } from '~/services/integrationLogsClient';

const props = defineProps<{
    entry: IntegrationLogEntry;
}>();
</script>
